
import api from '../../fetch/api'
import * as types from '../types'

const state = {
  // 用户登录状态
  loginStatus: JSON.parse(localStorage.getItem('loginStatus')) || false,
  // 用户登录信息
  userInfo: JSON.parse(localStorage.getItem('userInfo')) || {}

}

const getters = {
  loginStatus: state => state.loginStatus,
  userInfo: state => state.userInfo
}

const mutations = {
  [types.SET_USER_INFO] (state, res) {
    state.userInfo = res
  },
  [types.SET_LOGIN_STATUS] (state, status) {
    state.loginStatus = status
  }
}

const actions = {
  /**
     * 用户登录
     */
  setUserInfo ({ commit }, params) {
    var id = params.id
    var token = params.token
    console.log(token)
    api.getCustomerInfo(id, id, token).then(res => {
      let data = res.data
      let time = new Date().getTime()
      let customer = {
        NAME: data.NAME,
        GENDER: data.GENDER,
        EDUCATION: data.EDUCATION,
        JOB: data.JOB,
        ID_CARD: data.ID_CARD,
        PHONE_NUM: data.PHONE_NUM,
        CARD_TYPE: data.CARD_TYPE,
        CUSTOMER_ID: id,
        TOKEN: token,
        TIME: time
      }



      localStorage.setItem('userInfo', JSON.stringify(customer))
      localStorage.setItem('loginStatus', true)
      commit(types.SET_USER_INFO, customer)
      commit(types.SET_LOGIN_STATUS, true)
    })
  },
  setLogOut ({commit}) {
    localStorage.removeItem('userInfo')
    localStorage.removeItem('loginStatus')
    commit(types.SET_LOGIN_STATUS, false)
    commit(types.SET_USER_INFO, {})
  }
}

export default{
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/user.js